import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "home",
		component: () => import("../views/index.vue"),
	},
	{
		path: "/home.html",
		name: "home",
		component: () => import("../views/index.vue"),
	},
	{
		path: "/product.html",
		name: "product",
		component: () => import("../views/product.vue"),
	},
	{
		path: "/products.html",
		name: "products",
		component: () => import("../views/products.vue"),
	},
	{
		path: "/recruitment.html",
		name: "recruitment",
		component: () => import("../views/recruitment.vue"),
	},	
	{
		path: "/recruitments.html",
		name: "recruitments",
		component: () => import("../views/recruitments.vue"),
	},	
	{
		path: "/down.html",
		name: "down",
		component: () => import("../views/down.vue"),
	},
	{
		path: "/help.html",
		name: "help",
		component: () => import("../views/help.vue"),
	},
	// {
	// 	path: "/news",
	// 	name: "news",
	// 	component: () => import("../views/news.vue"),
	// },
	{
		path: "/about.html",
		name: "about",
		component: () => import("../views/about.vue"),
	},
	{
		path: "/business.html",
		name: "business",
		component: () => import("../views/business.vue"),
	},
	{
		path: "/open.html",
		name: "open",
		component: () => import("../views/open.vue"),
	},
	
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});
router.beforeEach((to, from, next) => {
	store.commit("ChangeCurrNav", to.name);
	next();
});
export default router;
